import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const LivestreamNotification = t0 => {
  const $ = _c(5);
  const {
    onClose,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span className="[&_button]:p-0 [&_button]:ml-[5px]"><Link to="/videos">{title}</Link></span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== t1) {
    t2 = <NotificationBannerSkeleton title="Video streaming now" body={t1} onClose={onClose} />;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
LivestreamNotification.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string
};
export default LivestreamNotification;